import React, { useState, useEffect, useRef } from "react";
import SearchBarComponent from "components/customs/searchbarV2";
import CustomDataTable from "components/customs/table";
import { defaultTableOption } from "constants/table";
import { ADD_ACTION } from "constants/actions";
import styled from "styled-components";
import addTVISettingsColumns from "./addTVISettingsCols";

const AddCourseTableHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 1rem;
  margin-bottom: 1rem;

  .custom-searchbar-container input {
    box-shadow: initial;
  }
`;

const SearchbarWrapper = styled.div`
  position: relative;
  justify-self: flex-end;

  input {
    box-shadow: none;
    border-radius: 9px;
    height: clamp(35px, 5vw, 50px);
  }
`;

const TableHeaderText = styled.h5`
  margin: 0;
`;

const AddCourseTableContainer = styled.div``;

const AddCourseTbl = styled.div`
  padding-left: 0.75rem;
  padding-right: 0.75rem;
  margin-top: 2rem;
  margin-bottom: 2rem;
  border-top: solid #cecece 1px;
  border-bottom: solid #cecece 1px;
`;

const NumberOfCoursesText = styled.span`
  letter-spacing: 0.1rem;
  font-weight: 600;
`;

const TotalAbscapText = styled.span`
  float: inline-end;
  letter-spacing: 0.1rem;
  font-weight: 600;
`;

const AddCourseTable = ({ data, setCourses, courses, action }) => {
  const [tableOption, setTableOption] = useState(defaultTableOption);

  const originalCapacityMap = useRef({});

  let changeSearchTimeoutID;

  const onChangeSearch = (event) => {
    event.persist();

    if (changeSearchTimeoutID) {
      clearTimeout(changeSearchTimeoutID);
    }

    changeSearchTimeoutID = setTimeout(() => {
      const eventValue = event.target.value.trim();

      if (eventValue.length !== 0) {
        const dataTable = tableOption.data.filter((item) =>
          item?.name?.toLowerCase()?.includes(eventValue)
        );

        setTableOption({
          ...tableOption,
          data: dataTable,
        });
      } else {
        setTableOption({
          ...tableOption,
          data,
        });
      }
    }, 1000);
  };

  const toggleCourseSelection = (row, checked) => {
    setCourses((prevCourses) => {
      let updatedCourses = prevCourses.filter(
        (course) => course.courseId !== 0
      );

      if (checked) {
        updatedCourses = [
          ...updatedCourses,
          {
            courseId: row.courseId,
            capacity: 0,
            courseCapacityId: row.courseCapacityId,
            ...(row.id != null ? { id: row.id } : {}),
          },
        ];
      } else {
        updatedCourses = updatedCourses.filter(
          (course) => course.courseId !== row.courseId
        );
      }

      return updatedCourses;
    });
  };

  const updateAbscap = (id, value) => {
    setCourses((prevCourses) =>
      prevCourses.map((course) =>
        course.courseId === id ? { ...course, capacity: Number(value) } : course
      )
    );
  };

  const totalAbscap = courses?.reduce(
    (sum, course) => sum + Number(course.capacity),
    0
  );

  const columns = addTVISettingsColumns({
    courses,
    action,
    originalCapacityMap,
    toggleCourseSelection,
    updateAbscap,
  });

  useEffect(() => {
    if (data) {
      setTableOption({
        ...tableOption,
        data,
      });
    }
  }, [data]);

  useEffect(() => {
    if (action === ADD_ACTION) return;
    if (Object.keys(originalCapacityMap.current).length > 0) return;
    if (!courses || courses.length === 0) return;

    const map = {};

    courses.forEach((c) => {
      map[c.courseId] = {
        capacity: Number(c.oldCapacityValue ?? c.capacity ?? 0),
        availableSlots: Number(c.availableSlots ?? 0),
      };
    });

    originalCapacityMap.current = map;
  }, [action, courses]);

  return (
    <AddCourseTbl>
      <AddCourseTableHeader>
        <TableHeaderText>{"Add Courses to this TVI"}</TableHeaderText>

        <SearchbarWrapper>
          <SearchBarComponent
            onChangeSearch={onChangeSearch}
            isDisabled={tableOption?.isLoading}
          />
        </SearchbarWrapper>
      </AddCourseTableHeader>

      <AddCourseTableContainer>
        <CustomDataTable
          columns={columns}
          data={tableOption.data}
          noHeader
          progressPending={tableOption.isLoading}
          height="calc(100vh - 200px)"
          paginationPerPage={5}
          paginationRowsPerPageOptions={[5, 10, 25, 50, 100]}
        />

        <div>
          <NumberOfCoursesText>
            {`No. of courses selected: ${courses?.length}`}
          </NumberOfCoursesText>
          <TotalAbscapText>{`Total ABSCAP: ${totalAbscap}`}</TotalAbscapText>
        </div>
      </AddCourseTableContainer>
    </AddCourseTbl>
  );
};

export default AddCourseTable;
